import { NetworkConfiguration } from "../../network/networkConfriguation";
import { callAPI } from "../../network/networkConnection";

const getIMPointsUsers = (query = "") => {
  return new Promise((resolve, reject) => {
    const base = process.env.REACT_APP_APIUrl + NetworkConfiguration.ADMIN_IM_POINTS_USERS;
    const url = query ? `${base}${query}` : base;
    callAPI(url, "GET", { "Content-Type": "application/json" })
      .then(resolve)
      .catch(reject);
  });
};

const assignIMPoints = (payload) => {
  return new Promise((resolve, reject) => {
    const url = process.env.REACT_APP_APIUrl + NetworkConfiguration.ADMIN_IM_POINTS_ASSIGN;
    callAPI(url, "POST", { "Content-Type": "application/json" }, JSON.stringify(payload))
      .then(resolve)
      .catch(reject);
  });
};

const updateIMPoints = (userId, payload) => {
  return new Promise((resolve, reject) => {
    if (!userId) {
      reject(new Error("User id is required for update"));
      return;
    }
    const url =
      process.env.REACT_APP_APIUrl + NetworkConfiguration.ADMIN_IM_POINTS_UPDATE + `/${userId}`;
    callAPI(url, "PUT", { "Content-Type": "application/json" }, JSON.stringify(payload))
      .then(resolve)
      .catch(reject);
  });
};

const getTransactions = (query = "") => {
  return new Promise((resolve, reject) => {
    const base =
      process.env.REACT_APP_APIUrl + NetworkConfiguration.ADMIN_IM_POINTS_TRANSACTIONS;
    const url = query ? `${base}${query}` : base;
    callAPI(url, "GET", { "Content-Type": "application/json" })
      .then(resolve)
      .catch(reject);
  });
};

const getUserIMPoints = () => {
  return new Promise((resolve, reject) => {
    const url = process.env.REACT_APP_APIUrl + NetworkConfiguration.USER_IM_POINTS;
    callAPI(url, "GET", { "Content-Type": "application/json" })
      .then(resolve)
      .catch(reject);
  });
};

export const imPointsApiService = {
  getIMPointsUsers,
  assignIMPoints,
  updateIMPoints,
  getTransactions,
  getUserIMPoints,
};
